import {
   ArcElement,
   BarController,
   BarElement,
   CategoryScale,
   Chart,
   DoughnutController,
   Filler,
   Legend,
   LinearScale,
   LineController,
   LineElement,
   PointElement,
   Tooltip,
} from 'chart.js';

let registered = false;

export const registerMainAnalyticsCharts = () => {
   if (registered) {
      return;
   }

   Chart.register(
      ArcElement,
      BarController,
      BarElement,
      CategoryScale,
      DoughnutController,
      Filler,
      Legend,
      LinearScale,
      LineController,
      LineElement,
      PointElement,
      Tooltip
   );

   registered = true;
};
